import { render, staticRenderFns } from "./RemediesList.vue?vue&type=template&id=29066954"
import script from "./RemediesList.vue?vue&type=script&lang=js"
export * from "./RemediesList.vue?vue&type=script&lang=js"
import style0 from "./RemediesList.vue?vue&type=style&index=0&id=29066954&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports